import { Component, inject, OnInit } from '@angular/core';
import { HeroComponent } from '../../components/hero/hero.component';
import { LogoBarComponent } from '../../components/logo-bar/logo-bar.component';
import { ProblemSectionComponent } from '../../components/problem-section/problem-section.component';
import { CopilotSectionComponent } from '../../components/copilot-section/copilot-section.component';
import { HowItWorksComponent } from '../../components/how-it-works/how-it-works.component';
import { TestimonialsComponent } from '../../components/testimonials/testimonials.component';
import { CtaSectionComponent } from '../../components/cta-section/cta-section.component';
import { SeoService } from '../../shared/seo.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HeroComponent,
    LogoBarComponent,
    ProblemSectionComponent,
    CopilotSectionComponent,
    HowItWorksComponent,
    TestimonialsComponent,
    CtaSectionComponent,
  ],
  template: `
    <app-hero />
    <app-logo-bar />
    <app-problem-section />
    <app-copilot-section />
    <app-how-it-works />
    <app-testimonials />
    <app-cta-section />
  `,
})
export class HomeComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.apply({
      title: 'AdRadar – LinkedIn Ads AI Copilot for B2B Teams',
      description: 'AdRadar deploys 7 AI agents that continuously optimise your LinkedIn Ads — targeting, bidding, scheduling, creative rotation & competitive intelligence. Built for B2B.',
      ogTitle: 'AdRadar — LinkedIn Ads AI Copilot',
      canonicalUrl: 'https://adradar.io/',
      schema: {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: 'AdRadar',
        applicationCategory: 'BusinessApplication',
        description: '7 AI agents that continuously optimise LinkedIn Ads — targeting, bidding, scheduling, creative rotation & competitive intelligence.',
        operatingSystem: 'Web',
        url: 'https://adradar.io',
        offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
      },
    });
  }
}
